import {
  App,
  Button,
  Card,
  Col,
  Input,
  message,
  Pagination,
  Row,
  Select,
  Tag,
} from "antd";
import { useCallback, useEffect, useState } from "react";
import CourseBox from "../../components/CourseBox";
import { useNavigate } from "react-router-dom";
import { COURSE_LIST, COURSE_STATUS, DELETE_COURSE, SET_ALL_CHAPTER_ORDER } from "../../apis/apis";
import debounce from "lodash.debounce";
import CulsightPageLoader from "../../components/CulsightPageLoader";

function Courses() {
  const Navigate = useNavigate();
  const { notification } = App.useApp();
  const [courses, set_courses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination_loader, set_pagination_loader] = useState(false);
  const [current_page, set_current_page] = useState("");
  const [total_pages, set_total_pages] = useState("");
  const [total_courses, set_total_courses] = useState(0);
  const [search_field, set_search_field] = useState("title"); // 'title' or 'tags'
  const [search_query, set_search_query] = useState("");
  const [isPublished, setIsPublished] = useState({});
  const [total_published_course, set_total_published_course] = useState(0);
  const [total_unpublished_course, set_total_unpublished_course] = useState(0);
  const [page_size, set_page_size] = useState(9);

  // API call to fetch courses
const fetchCourses = async (
  page = current_page || 1,
  size = page_size,
  searchValue = search_query,
  field = search_field
) => {
  setLoading(true);

  const FORM_DATA = new FormData();
  FORM_DATA.append("per_page", size);
  FORM_DATA.append("page", page);

  if (field === "title") FORM_DATA.append("title", searchValue);
  else FORM_DATA.append("tag", searchValue);

  const API_CALL = await COURSE_LIST(FORM_DATA);

  if (API_CALL?.data?.status) {
    set_courses(API_CALL.data?.data);
    set_total_courses(API_CALL.data?.total_courses);
    set_current_page(API_CALL?.data?.current_page);
    set_total_pages(API_CALL?.data?.total_pages);
    set_total_published_course(API_CALL?.data?.total_published_course);
    set_total_unpublished_course(API_CALL?.data?.total_unpublished_course);
  } else {
    console.log("error");
  }

  setLoading(false);
  set_pagination_loader(false);
};

useEffect(() => {
  fetchCourses(1, page_size);
}, [page_size]);

  // Pagination handler
 const pagination_on_change = async (page, size) => {
  set_pagination_loader(true);
  fetchCourses(page, size);
};
  // Debounced search function
const debouncedFetchResults = useCallback(
  debounce(async (value, field, size) => {
    set_pagination_loader(true);
    fetchCourses(1, size, value, field);
  }, 500),
  [current_page, page_size, search_query, search_field]
);
  // Input handler
  const handleInput = (e) => {
    const value = e.target.value;
    set_search_query(value); // update input immediately
    debouncedFetchResults(value, search_field,page_size);
  };

  // Select field change handler
  const handleSelectChange = (value) => {
    set_search_field(value);
    set_search_query(""); // reset input when field changes
  };

  const selectBefore = (
    <Select value={search_field} onChange={handleSelectChange}>
      <Select.Option value="title">Title</Select.Option>
      <Select.Option value="tag">Tags</Select.Option>
    </Select>
  );

  // Publish course
const publishCourse = async (course_id) => {
  const FORM_DATA = new FormData();
  FORM_DATA.append("id", course_id);

  try {
    const response = await COURSE_STATUS(FORM_DATA);
    if (response?.status) {
      message.success("Course published successfully!");

      setIsPublished((prev) => ({
        ...prev,
        [course_id]: true,
      }));

      await fetchCourses(current_page, page_size); // 👈 current page preserve
    } else {
      message.error(response?.message || "Failed to publish course");
    }
  } catch (error) {
    console.error("Error publishing course:", error);
    message.error("Something went wrong while publishing");
  }
};

  // Delete course
const deleteCourse = async (course_id) => {
  const FORM_DATA = new FormData();
  FORM_DATA.append("id", course_id);

  try {
    const response = await DELETE_COURSE(FORM_DATA);
    if (response?.status) {
     notification.success({
          message: "Successful",
          description: response?.data?.message,
        });
      await fetchCourses(current_page, page_size); // 👈 same page reload
    } else {
      message.error(response?.message || "Failed to delete course");
    }
  } catch (err) {
    console.error("Error deleting course:", err);
    message.error("Something went wrong");
  }
};    

const setallchapter = async (course_id) => {
  const FORM_DATA = new FormData();

  try {
    const response = await SET_ALL_CHAPTER_ORDER(FORM_DATA);
    if (response?.status) {
      message.success("Course deleted successfully");
      await fetchCourses(current_page, page_size); // 👈 same page reload
    } else {
      message.error(response?.message || "Failed to delete course");
    }
  } catch (err) {
    console.error("Error deleting course:", err);
    message.error("Something went wrong");
  }
};  


  return (
    <div className="lms-body">
      <Card>
        <h2>
          Courses
          <Button
            type="primary"
            size="large"
            onClick={() => Navigate("/add-courses")}
            style={{ marginLeft: "10px", float: "right" }}
          >
            Create Course
          </Button>

          {/* <Button type="primary" onClick={setallchapter} >update</Button> */}
        </h2>
        <br />


        <Row gutter={[10, 10]} style={{ marginBottom: "10px" }}>
          {/* Total Users */}    
          <Col lg={8} md={12} sm={24} xs={24}>
            <Card>
              <h3>
                Total Courses{" "}
                <span style={{ float: "right" }}>
                  <Tag
                    color="processing"
                    style={{ fontSize: "24px", padding: "15px" }}
                  >
                    {total_courses}
                  </Tag>
                </span>
              </h3>
              <p>Number of courses in system</p>
            </Card>
          </Col>

          {/* Active Users */}
          <Col lg={8} md={12} sm={24} xs={24}>
            <Card>
              <h3>
                Total Publish Courses{" "}
                <span style={{ float: "right" }}>
                  <Tag
                    color="success"
                    style={{ fontSize: "24px", padding: "15px" }}
                  >
                    {total_published_course}
                  </Tag>
                </span>
              </h3>
              <p>Number of publish courses in system</p>
            </Card>
          </Col>

          {/* Inactive Users */}
          <Col lg={8} md={12} sm={24} xs={24}>
            <Card>
              <h3>
                Total Unpublish Courses{" "}
                <span style={{ float: "right" }}>
                  <Tag
                    color="processing"
                    style={{ fontSize: "24px", padding: "15px" }}
                  >
                    {total_unpublished_course}
                  </Tag>
                </span>
              </h3>
              <p>Number of unpublish Courses in system</p>
            </Card>
          </Col>


        </Row>

        <Row gutter={[16, 16]} align="middle">
          <Col xs={24} sm={24} md={18} lg={12}>
            <Input
              addonBefore={selectBefore}
              placeholder={
                search_field === "title"
                  ? "Search by title"
                  : "Search by tags"
              }
              onChange={handleInput}
              size="large"
              style={{ width: "100%" }}
              value={search_query}
            />
          </Col>
        </Row>

        {loading ? (
          <CulsightPageLoader />
        ) : (
          <>
            <div className="courses-card" style={{ marginTop: "20px" }}>
              <Row gutter={[30, 40]}>
                {courses?.length > 0 ? (
                  courses.map((items) => (
                    <Col lg={8} md={8} sm={12} xs={24} key={items?.id}>
                      <CourseBox
                        id={btoa(items?.id)}
                        course_title={items?.title}
                        course_image={items?.thumbnail}
                        course_ribbon={items?.ribbon}
                        course_status={items?.status}
                        chapters_count={items?.chapters_count}
                        users_count={items?.users_count}
                        publishCourse={() => publishCourse(items?.id)}
                        isPublished={isPublished[items?.id] === true}
                        deleteCourse={() => deleteCourse(items?.id)}
                        updated_at ={items?.updated_at}
                      />
                    </Col>
                  ))
                ) : (
                  <Col lg={24} md={24} sm={24} xs={24}>
                    <p
                      style={{
                        textAlign: "center",
                        fontSize: "20px",
                        color: "red",
                        marginTop: "15px",
                      }}
                    >
                      Data Empty
                    </p>
                  </Col>
                )}
              </Row>
            </div>

            {total_pages > 0 ? (
              <div style={{ float: "right", marginTop: "20px" }}>
                  <Pagination
                    current={current_page}
                    total={total_courses}
                    pageSize={page_size}
                    showSizeChanger 
                    pageSizeOptions={['9', '18', '36', '71', '90']} 
                    onChange={pagination_on_change}
                    onShowSizeChange={(current, size) => {
                      set_page_size(size);
                      pagination_on_change(1, size);
                    }}     
                    style={{ display: 'inline-block' }}
                    className="no-search-pagination"
                  />
                  <style>
                    {`
                      .no-search-pagination .ant-select-selection-search-input {
                        display: none !important;
                      }
                    `}
                  </style>
              </div>
            ) : (
              <div style={{ textAlign: "center", color: "red" }}>
                <h2>No Courses Found</h2>
              </div>
            )}
          </>
        )}
      </Card>
    </div>
  );
}

export default Courses;
